import { POST_TYPE } from '@/constants/posts'
import { post } from '@/utils/axios'

const addComment = async (
  id: number,
  text: string | null,
  postType?: string,
  attachments?: Record<string, never>,
  attachmentType?: string
) => {
  let url = ''
  let body = {}
  if (postType === POST_TYPE.Community) {
    url = `/${POST_TYPE.Community}/v1/posts/${id}/comments`
    body = {
      type: attachmentType,
      content: {
        text,
        type: 'TEXT',
      },
      attachments,
    }
  } else {
    url = `/${POST_TYPE.Blog}/v1/post/${id}/comments`
    body = {
      type: attachmentType,
      content: text,
      attachments,
    }
  }

  try {
    return await post(url, body)
  } catch {
    return null
  }
}

export default addComment
